// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"efecb520","483":"6cf399d1"}[chunkId] + ".chunk.js";
};